export const ProductRegistrationStyles = {
  titleBar: {
    backgroundColor: "#64b5f6",
    padding: "8px",
    textAlign: "center",
    position: "sticky", // スクロール固定
    top: 0, // 画面上部固定
    zIndex: 1000,
  },
  titleText: {
    color: "white",
    fontWeight: "bold",
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "space-between",
    padding: "20px",
  },
  amazonButton: {
    alignSelf: "center",
    height: "40px", // 任意で固定高さも可
    backgroundColor: "#e0a56d",
    color: "white",
    fontWeight: "bold",
    boxShadow: 3,
    "&:hover": {
      backgroundColor: "#d79652",
    },
  },

  csvUploadButton: {
    alignSelf: "center",
    height: "40px",
    backgroundColor: "#e0a56d",
    color: "white",
    fontWeight: "bold",
    boxShadow: 3,
    "&:hover": {
      backgroundColor: "#d79652",
    },
  },
  fbaItem: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    backgroundColor: "rgba(111, 185, 255, 0.28)",
    p: 2,
    borderRadius: 2,
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    width: "100%",
    maxWidth: 680,
  },
  keywordInput: {
    width: "500px",
    marginRight: "8px",
    backgroundColor: "rgb(255, 255, 255)",
  },
  searchButton: {
    whiteSpace: "nowrap",
  },
  syncButton: {
    whiteSpace: "nowrap",
    marginLeft: "24px",
  },
  resetSyncNotice: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: 1,
    px: 2,
    mt: -1,
    mb: 2,
  },
  orangeButton: {
    backgroundColor: "#e0a56d",
    color: "white",
    fontWeight: "bold",
    boxShadow: 3,
    "&:hover": {
      backgroundColor: "#d79652",
    },
  },
  floatingRegisterButton: {
    position: "fixed",
    bottom: 24, // 画面下からの距離
    right: 24, // 画面右からの距離
    width: 90,
    height: 90,
    borderRadius: "50%",
    backgroundColor: "#e0a56d",
    color: "white",
    fontWeight: "bold",
    boxShadow: 6,
    zIndex: 2000,
    "&:hover": {
      backgroundColor: "#d79652",
    },
  },
};
